import { GoogleTagManager } from '@gasbuddy/dom-telemetry';
import logEvent from './logEvent';

GoogleTagManager.on('event', (eventName, eventAttributes) => {
  logEvent(`GoogleTagManager:${eventName}`, eventAttributes);
});

export default GoogleTagManager;
